<template>
  <div class="main-container">
    <header>
      <div class="top-bar">
        <img src="@/mos-logo.png" alt="logo" height="34px">
        <div class="select">首页</div>
        <div @click="goToPage('https://open.mobimedical.cn/docs/')">开发文档</div>
        <div class="drawer-btn" @click="showList = !showList"><img src="@/drawer-btn.png" alt="列表"></div>
      </div>
      <ul :class="[showList ? 'show-drawer' : '', 'drawer-list']">
        <li class="select">首页</li>
        <li @click="goToPage('https://open.mobimedical.cn/docs/')">开发文档</li>
      </ul>
      <div v-if="showList" class="mask-item" @click="showList = false"></div>
      <swiper
        class="main-swiper"
        :options="mainSwiperOptions"
      >
        <swiper-slide class="swiper1">
          <div class="main-swiper-content">
            <div class="main-swiper-title">MOS圆心医疗生态操作系统</div>
            <div class="main-swiper-txt1">助力医疗生态数字化转型、促进医疗生态合作共赢、赋能患者全生命周期健康管理</div>
<!--            <div class="main-swiper-button">观看视频<i class="iconfont icon-direction-right" style="margin-left: 14px" /></div>-->
          </div>
          <img src="@/mos-main-swiper1.png" alt="swiper1">
        </swiper-slide>
        <swiper-slide class="swiper1">
          <div class="main-swiper-content">
            <div class="main-swiper-title">MOS圆心医疗生态操作系统</div>
            <div class="main-swiper-txt1">助力医疗生态数字化转型、促进医疗生态合作共赢、赋能患者全生命周期健康管理</div>
<!--            <div class="main-swiper-button">观看视频<i class="iconfont icon-direction-right" style="margin-left: 14px" /></div>-->
          </div>
          <img src="@/mos-main-swiper1.png" alt="swiper1">
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </header>

    <!-- 主页面 -->
    <section>
      <ul>
        <li>
          <div class="ball price-ball"></div>
          <div class="main-title">MOS的价值</div>
          <div class="sub-title sub-txt-color">打破医疗数字化转型困局，创造连接的价值，赋能医疗新生态。</div>
          <div class="content-container mos-price">
            <scroll-to name="mos-price-card1" class="price-card1">
              <div class="price-title">单点接入 综而至简</div>
              <div class="price-describe sub-txt-color">
                <p>统一<span class="bigger">登录</span>入口，统一<span class="bigger">业务</span>入口，统一<span class="bigger">消息</span>入口</p>
                <p>统一<span class="bigger">权限</span>入口，统一<span class="bigger">权限</span>入口，统一<span class="bigger">任务</span>入口</p>
              </div>
              <img src="@/mos-price1.png" alt="mos">
            </scroll-to>
            <scroll-to name="mos-price-card2" delay-time="0.2s" class="price-card2">
              <div class="price-title">智慧管理 高效协同</div>
              <div class="price-describe sub-txt-color">协助院长统筹管理，协助科室主任业务管理，协助医生开展业务，协助方产业联动医院，协助医院跨组织协同，协助监管部门监管</div>
              <img src="@/mos-ball.svg" alt="ball" class="card-ball">
<!--              <div class="ball card-ball"></div>-->
            </scroll-to>
            <scroll-to name="mos-price-card3" class="price-card3">
              <div class="price-title">互联共生 应用千万</div>
              <div class="price-describe sub-txt-color">促进业务系统开放，打通办公数据，打通业务流程，打通监管渠道，打破组织壁垒，安全共享数据</div>
            </scroll-to>
            <scroll-to name="mos-price-card4" delay-time="0.2s" class="price-card4">
              <div class="price-title">创造多元价值</div>
              <div class="price-describe sub-txt-color">全院无纸化办公，减少接口重复开发费用，减少系统重复建设费用，降低智慧评级工作量，降低全院时间成本</div>
              <img src="@/mos-price4.png" alt="mos">
            </scroll-to>
          </div>
        </li>

        <li>
          <div class="ball engine-ball"></div>
          <div class="main-title">5大核心引擎</div>
          <div class="sub-title sub-txt-color">快速将线下业务线上化，覆盖医务管理应用全场景</div>
          <div class="content-container mos-engine">
            <scroll-to name="mos-engine-card1" class="engine-card">
              <div class="engine-title">流程引擎</div>
              <div class="split-line" />
              <div class="engine-icon1" />
              <div class="engine-describe sub-txt-color">适用各类院内OA流程，如文件处理、物资申购、人事审批等</div>
              <img class="engine-number" src="@/mos-number1.png" alt="mos">
            </scroll-to>
            <scroll-to name="mos-engine-card2" delay-time="0.1s" class="engine-card">
              <div class="engine-title">表单引擎</div>
              <div class="split-line" />
              <div class="engine-icon2" />
              <div class="engine-describe sub-txt-color">适用各类信息表单记录，如人事表单、设备管理表单、客户信息表单等</div>
              <img class="engine-number" src="@/mos-number2.png" alt="mos">
            </scroll-to>
            <scroll-to name="mos-engine-card3" delay-time="0.2s" class="engine-card">
              <div class="engine-title">随访引擎</div>
              <div class="split-line" />
              <div class="engine-icon3" />
              <div class="engine-describe sub-txt-color">适用各科室患者随访管理，自定义随访模板、计划，自动形成数据图表</div>
              <img class="engine-number" src="@/mos-number3.png" alt="mos">
            </scroll-to>
            <scroll-to name="mos-engine-card4" delay-time="0.3s" class="engine-card">
              <div class="engine-title">CMS引擎</div>
              <div class="split-line" />
              <div class="engine-icon4" />
              <div class="engine-describe sub-txt-color">适用各类内容管理应用，如通知公告、新闻原地、党员之家、信息公示等</div>
              <img class="engine-number" src="@/mos-number4.png" alt="mos">
            </scroll-to>
            <scroll-to name="mos-engine-card5" delay-time="0.4s" class="engine-card">
              <div class="engine-title">排班引擎</div>
              <div class="split-line" />
              <div class="engine-icon5" />
              <div class="engine-describe sub-txt-color">支持各科室排班及独立管理权限，可在线查看排班表、接收值班提醒</div>
              <img class="engine-number" src="@/mos-number5.png" alt="mos">
            </scroll-to>
          </div>
        </li>

        <li>
          <div class="main-title">积微迭变  MOS自有强大核心</div>
          <div class="sub-title sub-txt-color">6年沉淀、22万医职员工覆盖、300+个科室场景应用、4000+个业务流程、300万条流程数据</div>
          <div class="content-container mos-time">
            <scroll-to name="mos-time-left" class="time-left">
              <div class="time-title">院内办公</div>
              <div class="time-describe sub-txt-color">覆盖全院办公场景，预制丰富的院内办公应用，如通知公告、会议室预定、院内收发文、材料文件处理、任务管理、内部邮件、消息中心、日程中心、待办中心等。</div>
            </scroll-to>
            <scroll-to name="mos-time-right" delay-time="0.2s" class="time-right">
              <div class="time-card1">
                <div class="time-title">医务处理</div>
                <div class="time-describe sub-txt-color">为医院提供轻量化、移动化特色互联网医务应用，包含线上咨询、病历开方、CA审方、患者管理、医生/医助管理、随访管理、科研管理、远程会诊、线上转诊等。</div>
              </div>
              <div class="time-card2">
                <div class="time-title">人事管理</div>
                <div class="time-describe sub-txt-color">覆盖医院职工在职全周期管理，包含考勤管理、薪酬管理、绩效管理、招聘管理、组织管理、决策分析、人才档案储备等。</div>
              </div>
              <div class="absolute-line" />
              <div class="time-card3">
                <div class="time-title">后勤管理</div>
                <div class="time-describe sub-txt-color">高效协同医院后勤保障工作，如物资管理、医废管理、餐饮管理、能源管理、安全管理、设备设施及运送管理等。</div>
              </div>
              <div class="time-card4">
                <div class="time-title">专科平台</div>
                <div class="time-describe sub-txt-color">利用互联网连接医生与患者，医生在手机上完成管理患者、下发医嘱、安排未来日程、制定随访计划等操作，帮助患者获得连续性、周期性的就医服务体验。</div>
              </div>
            </scroll-to>
          </div>
        </li>

        <li>
          <div class="ball multi-ball"></div>
          <div class="main-title">多端协同 面向未来医疗的操作系统</div>
          <div class="sub-title sub-txt-color">轻量化·数字化·统一化</div>
          <scroll-to name="mos-multi-terminal" class="content-container mos-multi-terminal" @mousewheel.native="swiperWheel">
            <div v-if="isMask" class="swiper-mask"></div>
            <swiper
              class="multi-terminal-swiper"
              :options="multiSwiperOptions"
            >
              <swiper-slide ref="swiper1" class="swiper1">
                <div class="phone-content">
                  <p>一键开启 轻量化医院办公时代</p>
                  <p><span>灵活、便捷、</span>统一处理院务工作</p>
                </div>
                <div class="img-content">
                  <img class="swiper-phone1" src="@/mos-swiper-phone1.png" width="503px" alt="phone">
                  <img class="swiper-phone2" src="@/mos-swiper-phone2.png" width="436px" alt="phone">
                  <img class="swiper-phone3" src="@/mos-swiper-phone3.png" width="418px" alt="phone">
                </div>
              </swiper-slide>
              <swiper-slide ref="swiper2" class="swiper2">
                <div class="pad-content">
                  <p>全覆盖 <span>200+</span>日常办公应用场景</p>
                  <p>问诊、阅片、开会、随访不受限</p>
                </div>
                <div class="img-content">
                  <img class="swiper-pad1" src="@/mos-swiper-pad1.png" width="722px" alt="pad">
                  <img class="swiper-pad2" src="@/mos-swiper-pad2.png" width="410px" alt="pad">
                  <img class="swiper-pad3" src="@/mos-swiper-pad3.png" width="409px" alt="pad">
                </div>
              </swiper-slide>
              <swiper-slide ref="swiper3" class="swiper3">
                <div class="pc-content">
                  <p>从MOS开始 重新定义连接的价值</p>
                  <p><span>精准、高频、高效</span>互联对接全院系统</p>
                </div>
                <div class="img-content">
                  <img class="swiper-pc1" src="@/mos-swiper-pc1.png" width="794px" alt="pc">
                  <img class="swiper-pc2" src="@/mos-swiper-pc2.png" width="368px" alt="pc">
                  <img class="swiper-pc3" src="@/mos-swiper-pc3.png" width="394px" alt="pc">
                </div>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </scroll-to>
        </li>

        <li>
          <div class="ball open-ball"></div>
          <div class="main-title">MOS Open-API 开放连接全生态</div>
          <div class="sub-title sub-txt-color">通过MOS打通院内其他系统的对接，共创连接的价值</div>
          <scroll-to name="mos-open" class="content-container mos-open">
            <img class="open-left" src="@/mos-open.png" alt="mos">
            <div class="open-right">
              <scroll-to name="mos-open-card1" class="open-card1">
                <div class="open-title">企业身份校验</div>
                <div class="open-describe">通过开放协议识别用户身份，院内成员通过MOS访问其他三方应用时可以免密码安全登录</div>
              </scroll-to>
              <scroll-to name="mos-open-card2" class="open-card2">
                <div class="open-title">消息收发通道</div>
                <div class="open-describe">调用应用消息收发接口，院内通知可快速触达员工，让信息传递更高效</div>
              </scroll-to>
              <scroll-to name="mos-open-card3" class="open-card3">
                <div class="open-title">基础应用服务</div>
                <div class="open-describe">开放通知、收文、会议、打卡、审批等办公应用，通过接口自定义，获得更适合自身的服务</div>
              </scroll-to>
              <scroll-to name="mos-open-card4" class="open-card4">
                <div class="open-title">应用接入</div>
                <div class="open-describe">将院内已有的业务系统以应用的方式接入MOS，实现统一登录入口和消息推送</div>
              </scroll-to>
              <scroll-to name="mos-open-card5" class="open-card5">
                <div class="open-title">服务商广场</div>
                <div class="open-describe">获取第三方合作伙伴的开放接口，通过安全调用，丰富应用产品功能，满足医院多样化需求</div>
              </scroll-to>
              <scroll-to name="mos-open-card6" class="open-card6">
                <div class="more-btn">更多开放文档<i class="iconfont icon-arrow-right" /></div>
                <div class="open-title">开发者中心</div>
                <div class="open-describe">提供开发者社区交流平台、企业内的开发者们可相互解惑、交流经验，共同进步</div>
              </scroll-to>
            </div>
          </scroll-to>
        </li>

        <li>
          <div class="main-title">300+医院合作伙伴（部分）</div>
          <div class="sub-title sub-txt-color">顺势而上 参与未来医疗伟大进程</div>
          <div name="mos-partner" class="content-container mos-partner">
            <scroll-to :name="`mos-partner${index}`" v-for="(i, index) of partnerList" :key="i.name" class="partner-card">
              <img class="partner-img" :src="i.img" :width="i.width" alt="mos">
            </scroll-to>
          </div>
        </li>
      </ul>
    </section>

    <footer>
      <div class="footer-container">
        <div class="footer-content">
          <div class="footer-card">
            <div class="footer-title">关于义幻</div>
            <div class="footer-link" @click="goToPage('http://www.mobimedical.cn/a/gyyh/')">公司简介</div>
            <div class="footer-link" @click="goToPage('http://www.mobimedical.cn/a/gyyh/')">企业文化</div>
            <div class="footer-link" @click="goToPage('http://www.mobimedical.cn/a/yhxw/')">新闻动态</div>
            <div class="footer-link" @click="goToPage('http://www.mobimedical.cn/a/lxwm/')">加入我们</div>
          </div>
          <div class="footer-card">
            <div class="footer-title">解决方案及服务</div>
            <div class="footer-link" @click="goToPage('http://www.mobimedical.cn/a/jjfa/')">解决方案</div>
            <div class="footer-link" @click="goToPage('http://www.mobimedical.cn/a/hzal/')">服务方案</div>
          </div>
          <div class="footer-card">
            <div class="footer-title">联系我们</div>
            <div class="footer-link">联系方式：028-67695200</div>
            <div class="footer-link">E-mail：   yihuan@mobimedical.cn</div>
          </div>
          <div class="footer-card-last">
            <div class="footer-title">关注我们</div>
            <img class="qr-code" src="@/qr-code.png" alt="qr-code">
          </div>
        </div>
        <div class="split-line"></div>
        <div class="copy-right">
          <div>Copyright&nbsp;&nbsp;&nbsp;成都义幻医疗科技有限公司&nbsp;&nbsp;&nbsp;网站备案号：蜀ICP备15023217号-1</div>
          <div>成都市高新区府城大道天府新谷10号楼18F</div>
        </div>
        <div class="copy-right-mob">
          <div>Copyright&nbsp;&nbsp;&nbsp;成都义幻医疗科技有限公司</div>
          <div>网站备案号：蜀ICP备15023217号-1</div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import scrollTo from "./scrollTo";

  export default {
    name: 'Main',
    components: { scrollTo },
    data() {
      return {
        showList: false,
        mainSwiperOptions: {
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },
          pagination: {
            el: '.swiper-pagination'
          }
        },
        multiSwiperOptions: {
          effect: 'fade',
          mousewheel: true,
          fadeEffect: {
            crossFade: true
          },
          pagination: {
            el: '.swiper-pagination'
          }
        },
        isMask: false,
        partnerList: [
          { img: require('../assets/hospital/华西医院.png'), name: '华西医院' },
          { img: require('../assets/hospital/四川省人民医院.png'), name: '四川省人民医院' },
          { img: require('../assets/hospital/青海省人民医院.png'), name: '青海省人民医院' },
          { img: require('../assets/hospital/北京大学深圳医院.png'), name: '北京大学深圳医院' },
          { img: require('../assets/hospital/四川大学华西第二医院.png'), name: '四川大学华西第二医院' },
          { img: require('../assets/hospital/四川大学华西口腔医院.png'), name: '四川大学华西口腔医院' },
          { img: require('../assets/hospital/四川大学华西第四医院.png'), name: '四川大学华西第四医院' },
          { img: require('../assets/hospital/四川省骨科医院.png'), name: '四川省骨科医院' },
          { img: require('../assets/hospital/四川省中医医院.png'), name: '四川省中医医院' },
          { img: require('../assets/hospital/四川省第二中医院.png'), name: '四川省第二中医院' },
          { img: require('../assets/hospital/成都市第一人民医院.png'), name: '成都市第一人民医院' },
          { img: require('../assets/hospital/深圳南山医院.png'), name: '深圳南山医院' },
          { img: require('../assets/hospital/成都市第五人民医院.png'), name: '成都市第五人民医院' },
          { img: require('../assets/hospital/淮北市人民医院.png'), name: '淮北市人民医院' },
          { img: require('../assets/hospital/青海省中医院.png'), name: '青海省中医院' },
          { img: require('../assets/hospital/成都大学附属医院.png'), name: '成都大学附属医院' },
          { img: require('../assets/hospital/成都市第四人民医院.png'), name: '成都市第四人民医院' },
          { img: require('../assets/hospital/淮北矿工总医院.png'), name: '淮北矿工总医院' },
          { img: require('../assets/hospital/北京中医药大学东方医院.png'), name: '北京中医药大学东方医院' },
          { img: require('../assets/hospital/绵阳市第三人民医院.png'), name: '绵阳市第三人民医院' },
          { img: require('../assets/hospital/宜宾市第一人民医院.png'), name: '宜宾市第一人民医院' },
          { img: require('../assets/hospital/遂宁市中心医院.png'), name: '遂宁市中心医院' },
          { img: require('../assets/hospital/广元市中心医院.png'), name: '广元市中心医院' },
          { img: require('../assets/hospital/广元市市第一人民医院.png'), name: '广元市市第一人民医院' }
        ],
        flag: true
      }
    },
    methods: {
      goToPage(url) {
        window.open(url)
      },

      swiperWheel(e) {
        let start = this.$refs.swiper1.$el.classList.contains('swiper-slide-active')
        let end = this.$refs.swiper3.$el.classList.contains('swiper-slide-active')
        if ((e.deltaY > 0 && end)  || (e.deltaY < 0 && start)) {
          // 在最后一张轮播图向下滚动
          setTimeout(() => {
            this.isMask = true
            setTimeout(() => {
              this.isMask = false
            }, 2000)
          }, 200)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@import './main.scss';
</style>
